import { Button } from "@/components/ui/button";
import { ReactNode, useState } from "react";
import {
  Dialog,
  DialogTrigger,
  DialogTitle,
  DialogHeader,
  DialogContent,
} from "@/components/ui/dialog";
import { CreateServiceAreaForm } from "./create-service-area-form";

interface CreateServiceAreaButtonProps {
  trigger?: ReactNode;
}

export function CreateServiceAreaButton({
  trigger,
}: CreateServiceAreaButtonProps) {
  const [isOpen, setIsOpen] = useState(false);

  const onSuccess = () => {
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        {trigger ?? (
          <Button variant="default" title="Create New Service Area">
            Create Service Area
          </Button>
        )}
      </DialogTrigger>
      <DialogContent className="sm:max-w-[800px]">
        <DialogHeader>
          <DialogTitle>Create New Fee</DialogTitle>
        </DialogHeader>
        <CreateServiceAreaForm onSuccess={onSuccess} />
      </DialogContent>
    </Dialog>
  );
}
